// extracted by mini-css-extract-plugin
module.exports = {"CardCover":"styles_CardCover__67Q5w","featured":"styles_featured__B6GQ5","duration":"styles_duration__RL99t","icon":"styles_icon__kEn_E"};